import React, { PropsWithChildren } from "react";
//#region types
import { FileUploaderProps } from "models/propTypes/fileUploaderPropTypes";
import { TranslationKeys } from "translations";
import { IconDefinitionConstants } from "utils/constants";
//#endregion
//#region compnents
import FileUploaderErrors from "./fileUploaderErrors";
import FilesGridContainer from "./filesGridContainer";
import Icon from "../../../icon";
import { Grid } from "@mui/material";
//#endregion
//#region helpers
import { LocalizationHelperInstance } from "utils/helpers";
//#endregion
import cssExports from "theme/styles/main.module.scss";
import clsx from "clsx";

const FileUploaderLite: React.FC<PropsWithChildren<FileUploaderProps>> = (props) => {
  const {
    dragging,
    remainingFiles,
    invalidFileType,
    invalidFileSize,
    hasEmptyFile,
    beyondMaxAmountOfFiles,
    maxFileSize,
    allowedMaxFileCount,
    files,
    fileTypes,
    hideFileTypes,
    onDrag,
    onDragStart,
    onDragEnd,
    onDragOver,
    onDragEnter,
    onDragLeave,
    onDrop,
    handleClose,
    onStopReading,
  } = props;

  const hasError = invalidFileType || invalidFileSize || beyondMaxAmountOfFiles || hasEmptyFile;

  const active = (hasError && !dragging) || remainingFiles.length > 0 || files.length > 0;

  return (
    <React.Fragment>
      {active || dragging ? (
        <Grid item xs={12} className={cssExports.fileUploaderRoot}>
          <Grid
            item
            container
            className={cssExports.fileUploaderLite}
            onDrag={onDrag}
            onDragStart={onDragStart}
            onDragEnd={onDragEnd}
            onDragOver={onDragOver}
            onDragEnter={onDragEnter}
            onDragLeave={onDragLeave}
            onDrop={onDrop}
          >
            {dragging && (
              <Grid
                item
                container
                className={clsx(
                  cssExports.fileUploader,
                  cssExports.fileUploaderDragging,
                  hasError ? cssExports.fileUploaderError : ""
                )}
              >
                <Grid item container direction="row">
                  <Grid item>
                    <Grid item className={cssExports.fileUploaderInput}>
                      <Icon icon={IconDefinitionConstants.WCloudUpload} />
                    </Grid>
                  </Grid>
                  <Grid item container xs direction="column" className={cssExports.fileUploaderInputTextContainer}>
                    <Grid
                      item
                      className={cssExports.fileUploaderText}
                      container
                      direction="column"
                      alignItems="flex-start"
                    >
                      <Grid item className={cssExports.fileUploaderTextBrowse}>
                        {`${LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.DropFileMessage)} `}
                      </Grid>

                      {!hideFileTypes && (
                        <Grid item className={cssExports.fileUploaderSubText}>
                          {`${LocalizationHelperInstance.getFormattedMessage(
                            TranslationKeys.Common.FileFormatsMessage
                          )} ${fileTypes}`}
                        </Grid>
                      )}
                    </Grid>
                    {hasError && (
                      <>
                        <Grid item className={cssExports.errorMessageContainer}>
                          <FileUploaderErrors
                            invalidFileType={invalidFileType}
                            invalidFileSize={invalidFileSize}
                            hasEmptyFile={hasEmptyFile}
                            beyondMaxAmountOfFiles={beyondMaxAmountOfFiles}
                            maxFileSize={maxFileSize}
                            allowedMaxFileCount={allowedMaxFileCount}
                          ></FileUploaderErrors>
                        </Grid>
                        <Grid item className={cssExports.fileUploaderErrorIcon}>
                          !
                        </Grid>
                      </>
                    )}
                  </Grid>
                </Grid>
              </Grid>
            )}

            {active && (
              <Grid item container>
                <Grid item xs={1} className={cssExports.fileSubmitContainer} onClick={props.onSelectFileClick}>
                  <Icon icon={IconDefinitionConstants.WAttachment} className={cssExports.inputIcon} />
                  {props.children}
                </Grid>

                <Grid container item xs={11} className={cssExports.fileUploaderFileContainer}>
                  {hasError && !dragging && (
                    <FileUploaderErrors
                      invalidFileSize={invalidFileSize}
                      invalidFileType={invalidFileType}
                      hasEmptyFile={hasEmptyFile}
                      beyondMaxAmountOfFiles={beyondMaxAmountOfFiles}
                      uploadedOnlyMax={beyondMaxAmountOfFiles && !dragging}
                      maxFileSize={maxFileSize}
                      allowedMaxFileCount={allowedMaxFileCount}
                      errorBubbles
                    ></FileUploaderErrors>
                  )}
                  <FilesGridContainer
                    files={files}
                    remainingFiles={remainingFiles}
                    onStopReading={onStopReading}
                    handleClose={handleClose}
                  ></FilesGridContainer>
                </Grid>
              </Grid>
            )}
          </Grid>
        </Grid>
      ) : (
        <></>
      )}
      {!active ? (
        <Grid item xs={1} className={cssExports.fileUploaderRoot}>
          <Grid
            item
            container
            className={clsx(cssExports.fileUploaderLite)}
            onDrag={onDrag}
            onDragStart={onDragStart}
            onDragEnd={onDragEnd}
            onDragOver={onDragOver}
            onDragEnter={onDragEnter}
            onDragLeave={onDragLeave}
            onDrop={onDrop}
          >
            <Grid
              item
              container
              className={cssExports.fileSubmitContainer}
              onClick={props.onSelectFileClick}
              justifyContent="center"
            >
              <Icon icon={IconDefinitionConstants.WAttachment} className={cssExports.inputIcon} />
              {props.children}
            </Grid>
          </Grid>
        </Grid>
      ) : (
        <Grid item xs={1}></Grid>
      )}
    </React.Fragment>
  );
};

export default FileUploaderLite;
